import * as yup from 'yup'

export const createNewCustomerSchema = yup.object().shape({
    customer: yup.object().shape({
        customer_industry: yup.string().required('Chưa chọn ngành nghề'),
        customer_service_interestings: yup
            .array()
            .min(1, 'Chưa chọn dịch vụ quan tâm'),
        customer_name: yup.string().required('Chưa nhập tên khách hàng'),
        customer_email: yup
            .string()
            .required('Chưa nhập email')
            .email('Email không hợp lệ'),
        customer_position: yup.string().required('Chưa nhập vị trí'),
        customer_phone: yup.string().required('Chưa nhập số điện thoại'),
        customer_sale_followers: yup
            .array()
            .min(1, 'Chưa chọn Sales phụ trách'),
    }),
    company: yup.object().shape({
        // FilterSelectAsync stores { label, value } object or number
        company_id: yup
            .mixed()
            .test('company-required', 'Chưa chọn công ty', (val) => {
                if (typeof val === 'object' && val !== null)
                    return (val as any).value > 0
                return typeof val === 'number' && val > 0
            }),
    }),
})
